// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__vH1O9","filesListContainer":"PosDisputesFiles_filesListContainer__2eiiB","filesButton":"PosDisputesFiles_filesButton__2M0as"};